import React from "react"
import MustacheEditor from "../../../components/MustacheEditor/MustacheEditor"
import {EmailTemplate} from "../../../resources/emailTemplates"
import {DomainFilter} from "../../../components/DomainFilter/DomainFilter"

export const EditEmailTemplate = ({
	editingTemplate,
	forcePublish,
	setForcePublish,
	error,
	handleSaveTemplate,
	filteredDomains,
	setFilteredDomains,
}: {
	editingTemplate: EmailTemplate
	forcePublish: boolean
	setForcePublish: (forcePublish: boolean) => void
	error: string | null
	handleSaveTemplate: (htmlContent: string, subject?: string, samples?: string) => void
	filteredDomains: string[]
	setFilteredDomains: (filteredDomains: string[]) => void
}) => {
	return (
		<div className="email-template-editor-container">
			<div className="email-template-editor-header">
				<h2>Editing Template: {editingTemplate.attributes.subject}</h2>
				<p>Template ID: {editingTemplate.attributes.templateId}</p>
				<p>Current Version: {editingTemplate.attributes.version}</p>
				<div className="template-form-fields">
					<div className="publish-option flex-75">
						<label>
							<input type="checkbox" checked={forcePublish} onChange={(e) => setForcePublish(e.target.checked)} />
							<span> Publish this version immediately</span>
						</label>
					</div>
					<div className="form-field flex-25">
						<label htmlFor="templateId">Domain</label>
						<DomainFilter statuses={filteredDomains} setStatuses={setFilteredDomains} singleOption />
					</div>
				</div>

				{error && <div className="error-message">{error}</div>}
			</div>

			<MustacheEditor
				initialHtml={editingTemplate.attributes.htmlContent}
				onSave={handleSaveTemplate}
				initialSubject={editingTemplate.attributes.subject}
				showSubjectField={true}
				samples={editingTemplate.attributes.samples}
			/>
		</div>
	)
}
